






import { Component, Vue } from "vue-property-decorator";
import router, { asyncRouter } from "./router/index";
import { log } from "util";

import { UserModule } from "@/store/modules/user";
import { AppModule } from "@/store/modules/app";


@Component({
  name: "App"
})
export default class extends Vue {

}
